import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const LengthFeet = ({ length }: SpecProps<"length">) => {
  const { i18n } = useLingui();

  if (length == null || length === 0) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.length.feet",
    message: "Length in feet",
    comment: "Field for 'length in feet' in ad specification",
  });
  const value = i18n.t({
    id: "itemPageLayout.common.length.feet.value",
    message: "{length} feet",
    comment: "Field for 'length in feet' in ad specification",
    values: { length: length },
  });

  return <FieldValuePair field={field} value={value} />;
};
